// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__i8Suq","header":"ReportDetails_header__HnJgF","title":"ReportDetails_title__374nd","left":"ReportDetails_left__128r8"};